import { type Emitter, mitt } from '@utopia-utils/core'

type Events = {
  addTaskSuccess: HTMLElement | void
}

export const downloadCenterEvent: Emitter<Events> = mitt<Events>()
